import { useEffect } from "react";
import { css } from "goober";

import globals from "@/util/global-whitelist.mjs";

const SCALE_BASIS = 1920;
const makeStyle = (scale: number) => css`
  .scaled {
    --scale-factor: ${scale};
    transform: scale(var(--scale-factor));
    transform-origin: 0 0;
  }
`;

let injectClass = null;
const updateScaleFactor = () => {
  globals.document.body.classList.remove(injectClass);
  injectClass = makeStyle(globals.innerWidth / SCALE_BASIS);
  globals.document.body.classList.add(injectClass);
};

const useOverlayStyle = () =>
  useEffect(() => {
    updateScaleFactor();

    globals.addEventListener("resize", updateScaleFactor, { passive: true });

    return () => {
      globals.removeEventListener("resize", updateScaleFactor);
    };
  }, []);

export default useOverlayStyle;
